<template>
  <div>
    <div class="tab-plan verify-tab">
      <div v-if="themeConfig.showKYCTips && showKycTips" class="kyc-tips">
        <!-- 有第三方 kyc 驗證 -->
        <template v-if="kyc_brand">
          <i class="icon-alert">
            <img :src="$getThemeImagePath('icon_alert.png')" alt="">
          </i>
          <p class="kyc-tipContent">
            <template v-if="memberInfo.is_pass_KYC === 1">
              {{ $t("Bao.KYC_has_third_completed") }}
            </template>
            <template v-else-if="isSetData">
              {{ $t("Bao.KYC_need_third_completed") }}
            </template>
            <template v-else>
              {{ $t("Bao.KYC_has_third_not_complete") }}
            </template>
          </p>
          <div
            v-if="memberInfo.is_pass_KYC !== 1 && isSetData"
            class="btn btn-style-primary kyc-bn-gold"
            @click="save()"
          >
            {{ $t("Bao.KYC_has_third_completed_btn") }}
          </div>
        </template>
        <!-- 未經過驗證 -->
        <template v-if="!kyc_brand && memberInfo.is_pass_KYC === 0">
          <i class="icon-alert">
            <img :src="$getThemeImagePath('icon-alert-kyc.png')" alt="">
          </i>
          <p class="kyc-tipContent">
            <span class="t-highlight">{{ $t("Bao.KYC_not_complete_1") }}</span>
            {{ $t("Bao.KYC_not_complete_2") }}
          </p>
        </template>
        <!-- 已驗證 -->
        <template v-if="!kyc_brand && memberInfo.is_pass_KYC === 1">
          <i class="icon-alert">
            <img :src="$getThemeImagePath('icon-alert-kyc.png')" alt="">
          </i>
          <p class="kyc-tipContent">
            {{ $t("Bao.KYC_has_completed_1") }}
            <span class="t-highlight">{{ $t("Bao.KYC_has_completed_2") }}</span>
            {{ $t("Bao.KYC_has_completed_3") }}
            <span class="t-highlight"> {{ $t("Bao.KYC_has_completed_4") }}</span>
            {{ $t("Bao.KYC_has_completed_5") }}
          </p>
        </template>
      </div>

      <div class="verify-form">
        <template v-if="isShowMemberInfo">
          <div class="verify-form-title">
            {{ $t('Bao.personal_info') }}
          </div>

          <div class="row-frame gx-3 gy-3">
            <div class="colu colu-12 flex-colu">
              <label class="colu-12 for-label fs-14px fw-400" for="nationality">
                {{ $t('Bao.nationality') }}
                <span class="t-highlight">＊</span>
              </label>
              <select
                id="nationality"
                v-model="updateUser.nationality"
                v-validate="'required'"
                class="for-input"
                :class="{ 'isInvalid': errors.has('nationality') }"
                name="nationality"
                :data-vv-as="$t('Bao.nationality')"
                :disabled="!!memberInfo.nationality"
              >
                <option value="">
                  {{ $t('Bao.please_select') }}
                </option>
                <option
                  v-for="item in nationalityOptions"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <div v-if="errors.has('nationality')" class="input-feedback text-align-R">
                {{ $t('Bao.nationality_error') }}
              </div>
            </div>
            <div class="colu colu-12 colu-lg-6 flex-colu">
              <label class="colu-12 for-label fs-14px fw-400">
                {{ nameLabels.nameLast }}
                <span class="t-highlight">＊</span>
              </label>
              <template v-if="memberInfo.name">
                <input
                  v-model="lastName"
                  class="for-input inpType"
                  type="text"
                  disabled
                >
              </template>
              <template v-else>
                <input
                  v-model="lastName"
                  v-validate="'required'"
                  class="for-input inpType"
                  :class="{ 'isInvalid': errors.has('last_name')}"
                  type="text"
                  name="last_name"
                  :data-vv-as="$t('Bao.last_name')"
                  :placeholder="namePlaceholders ? namePlaceholders.nameLast : $t('Bao.name_content')"
                  @input="validateNameLast"
                >
              </template>
              <div v-if="errors.has('last_name')" class="input-feedback text-align-R">
                {{ $t('Bao.last_name_error') }}
              </div>
            </div>
            <div class="colu colu-12 colu-lg-6 flex-colu">
              <label class="colu-12 for-label fs-14px fw-400">
                {{ nameLabels.nameFirst }}
                <span class="t-highlight">＊</span>
              </label>
              <template v-if="memberInfo.name">
                <input
                  v-model="firstName"
                  type="text"
                  class="for-input inpType"
                  disabled
                >
              </template>
              <template v-else>
                <input
                  v-model="firstName"
                  v-validate="'required'"
                  class="for-input inpType"
                  :class="{ 'isInvalid': errors.has('first_name')}"
                  type="text"
                  name="first_name"
                  :data-vv-as="$t('Bao.first_name')"
                  :placeholder="namePlaceholders ? namePlaceholders.nameFirst : $t('Bao.name_content')"
                  @input="validateNameFirst"
                >
              </template>
              <div v-if="errors.has('first_name')" class="input-feedback text-align-R">
                {{ $t('Bao.first_name_error') }}
              </div>
            </div>
            <template v-if="!isTheme('theme_blue')">
              <div class="colu colu-12 colu-lg-6 flex-colu">
                <label class="colu-12 for-label fs-14px fw-400">
                  {{ nameLabels.romLast }}
                  <span class="t-highlight">＊</span>
                </label>
                <template v-if="memberInfo.romanization">
                  <input
                    v-model="romanizationOfLastName"
                    type="text"
                    class="for-input inpType"
                    disabled
                  >
                </template>
                <template v-else>
                  <input
                    v-model="romanizationOfLastName"
                    v-validate="'required'"
                    class="for-input inpType"
                    :class="{ 'isInvalid': errors.has('romanizationOfLastName') || romanLastError }"
                    type="text"
                    name="romanizationOfLastName"
                    :data-vv-as="$t('Bao.romanization_of_last_name')"
                    :placeholder="namePlaceholders ? namePlaceholders.romLast : ''"
                    @input="validateRomLastName"
                  >
                </template>
                <div v-if="errors.has('romanizationOfLastName')" class="input-feedback text-align-R">
                  {{ $t('Bao.romanization_of_last_name_error') }}
                </div>
                <div v-else-if="romanLastError" class="input-feedback text-align-R">
                  {{ romanLastError }}
                </div>
              </div>
              <div class="colu colu-12 colu-lg-6 flex-colu">
                <label class="colu-12 for-label fs-14px fw-400">
                  {{ nameLabels.romFirst }}
                  <span class="t-highlight">＊</span>
                </label>
                <template v-if="memberInfo.romanization">
                  <input
                    v-model="romanizationOfFirstName"
                    class="for-input inpType"
                    type="text"
                    disabled
                  >
                </template>
                <template v-else>
                  <input
                    v-model="romanizationOfFirstName"
                    v-validate="'required'"
                    class="for-input inpType"
                    :class="{ 'isInvalid': errors.has('romanizationOfFirstName') || romanFirstError }"
                    type="text"
                    name="romanizationOfFirstName"
                    :data-vv-as="$t('Bao.romanization_of_first_name')"
                    :placeholder="namePlaceholders ? namePlaceholders.romFirst : ''"
                    @input="validateRomFirstName"
                  >
                </template>
                <div v-if="errors.has('romanizationOfFirstName')" class="input-feedback text-align-R">
                  {{ $t('Bao.romanization_of_first_name_error') }}
                </div>
                <div v-else-if="romanFirstError" class="input-feedback text-align-R">
                  {{ romanFirstError }}
                </div>
              </div>
            </template>
            <div class="colu colu-12 colu-lg-6 flex-colu">
              <label class="colu-12 for-label fs-14px fw-400">
                {{ $t("Bao.birthday") }}
                <span class="t-highlight">＊</span>
              </label>
              <template v-if="memberInfo.birthday">
                <input
                  type="text"
                  class="for-input inpType"
                  :value="memberInfo.birthday"
                  disabled
                >
              </template>
              <template v-else>
                <input
                  v-model="updateUser.birthday"
                  v-validate="'required|date_format:yyyy-MM-dd|before:' + maxDate"
                  class="for-input inpType"
                  :class="{ 'isInvalid': errors.has('birthday') }"
                  type="date"
                  name="birthday"
                  :data-vv-as="$t('Bao.birthday')"
                  :max="maxDate"
                >
              </template>
              <div v-if="errors.has('birthday')" class="input-feedback text-align-R">
                {{ $t('Bao.birthday_error') }}
              </div>
            </div>
            <div class="colu colu-12 colu-lg-6 flex-colu">
              <label class="colu-12 for-label fs-14px fw-400">
                {{ $t("Bao.address") }}
                <span class="t-highlight">＊</span>
              </label>
              <input
                v-model="updateUser.address"
                v-validate="'required'"
                class="for-input inpType"
                :class="{ 'isInvalid': errors.has('address') }"
                type="text"
                name="address"
                :placeholder="pleaseEnterTip('address')"
                :disabled="memberInfo.is_pass_KYC === 1"
              >
              <div v-if="errors.has('address')" class="input-feedback text-align-R">
                {{ $t('Bao.address_error') }}
              </div>
            </div>
          </div>

          <div class="verify-form-title">
            {{ $t("Bao.contact_info") }}
          </div>
          <div class="row-frame gx-3">
            <div class="colu-12">
              <label class="colu-12 for-label fs-14px fw-400" for="メールアドレス">{{ $t("Bao.e-mail") }}
                <span class="t-highlight">＊</span>
              </label>
            </div>
            <div class="colu colu-8 colu-md-9 colu-lg-10">
              <input
                v-if="memberInfo.email_validate === 0"
                id="eMail"
                v-model="updateUser.email"
                v-validate="'required'"
                class="for-input inpType"
                type="email"
                name="email"
                :placeholder="memberInfo.email"
              >
              <input
                v-else
                id="eMail"
                class="for-input inpType"
                type="text"
                name="check_lite_email"
                :value="memberInfo.email"
                :disabled="memberInfo.email_validate === 1"
              >
            </div>
            <div class="colu colu-4 colu-md-3 colu-lg-2">
              <button
                :disabled="memberInfo.email_validate === 1 && updateUser.email"
                class="btn btn-settings set-email btn-stroke button-style flex-fill"
                @click="goVerifyEmail"
              >
                {{ $t("Bao.verify_register") }}
              </button>
            </div>
          </div>

          <div class="row-frame gx-3">
            <div class="colu-12">
              <label class="colu-12 for-label fs-14px fw-400" for="メールアドレス">{{ $t("Bao.phone") }}
                <span class="t-highlight">＊</span>
              </label>
            </div>
            <div class="colu-8 colu-md-9 colu-lg-10 country-select-frame">
              <div class="colu">
                <div class="colu-4 colu-sm-3 colu-lg-2 country-select-box" :class="{ active: isActive }" @click="toggleActive">
                  <div class="form-select-1 country-select">
                    <div class="form-select-value">
                      <div class="country-flag" />
                      <div class="country-code">
                        {{ selectedCode }}
                      </div>

                      <div class="country-list-box">
                        <ul class="country-list">
                          <li
                            v-for="(code, key) in brand.supportPhoneCode"
                            :key="key"
                            @click.stop="selectCode(code)"
                          >
                            <div class="country-flag" />
                            <div class="country-code">
                              {{ code }}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <i class="fa-solid fa-angle-right " aria-hidden="true" />
                </div>
                <div class="colu-8 colu-sm-9 colu-lg-10 number-box">
                  <input
                    v-if="memberInfo.phone_validate === 0"
                    id="phoneNumber"
                    v-model="phone"
                    v-validate="'required'"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': phoneError && phoneError !== $t('Bao.phone_available') }"
                    type="text"
                    autocomplete="off"
                    @input="phonecheck"
                  >
                  <input
                    v-if="memberInfo.phone_validate === 1"
                    id="phoneNumber"
                    :placeholder="updateUser.phone"
                    type="text"
                    class="colu-12 for-input inpType"
                    disabled
                  >
                  <div v-if="phoneError === $t('Bao.phone_available')" class="account_good text-align-R">
                    {{ phoneError }}
                  </div>
                  <div v-else-if="phoneError" class="input-feedback text-align-R">
                    {{ phoneError }}
                  </div>
                </div>
              </div>
            </div>

            <div class="colu colu-4 colu-md-3 colu-lg-2">
              <button
                :disabled="memberInfo.phone_validate === 1 && updateUser.phone"
                class="btn btn-settings set-email btn-stroke button-style flex-fill"
                @click="goVerifyPhone"
              >
                {{ $t("Bao.verify_register") }}
              </button>
            </div>
          </div>
        </template>

        <div class="verify-form-title">
          {{ $t("Bao.setting_password") }}
        </div>
        <div class="row-frame gx-3 gy-3">
          <!-- 變更登入密碼 -->
          <div class="colu colu-8 colu-md-9 colu-lg-10 flex-colu justify-content-center">
            <p class="fs-12px" style="color: var(--text-tertiary, #848484); margin: 0;">
              {{ $t(`Bao.user_verify_password_${mode}`) }}
            </p>
          </div>
          <div class="colu colu-4 colu-md-3 colu-lg-2">
            <button class="btn btn-stroke button-style flex-fill btn-get-verify-code" @click="openVerifyPassword('login')">
              <span>{{ $t("Bao.user_verify_get_code") }}</span>
            </button>
          </div>
          <!-- 變更提款密碼 -->
          <div class="colu colu-8 colu-md-9 colu-lg-10 flex-colu justify-content-center">
            <p class="fs-12px" style="color: var(--text-tertiary, #848484); margin: 0;">
              {{ $t(`Bao.user_verify_password_withdrawal_${mode}`) }}
            </p>
          </div>
          <div class="colu colu-4 colu-md-3 colu-lg-2">
            <button class="btn btn-stroke button-style flex-fill btn-get-withdrawal-verify-code" @click="openVerifyPassword('withdrawal')">
              <span>{{ $t("Bao.user_verify_get_code") }}</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="isShowMemberInfo || isShowKYC" class="row-frame gy-3">
        <div class="colu colu-12">
          <button
            :disabled="isSendButtonDisabled"
            class="btn btn-tertiary flex-fill"
            @click="save()"
          >
            <template v-if="kyc_brand && memberInfo.is_pass_KYC !== 1">
              {{ $t("Bao.KYC_has_third_completed_btn") }}
            </template>
            <template v-else>
              {{ memberInfo.is_pass_KYC === 0 ? $t("Bao.next") : $t("Bao.save_setting") }}
            </template>
          </button>
        </div>
      </div>

      <!-- 聯絡資訊 驗證彈窗 -->
      <div
        v-if="isShowVerifyEmail || isShowVerifyPhone"
        class="popup-wrap register-wrap fun-sec-authen"
        :class="{ active: isShowVerifyEmail || isShowVerifyPhone }"
      >
        <div class="popup-box fullScreen-md">
          <a class="popup-close" @click="closeVerify"><i class="fa-solid fa-xmark" /></a>
          <div class="form-popup popup-padding">
            <form class="row-frame dep-form-frame reg-popupBox">
              <h4 class="register-title font-w-b text-align-L">
                <template v-if="isShowVerifyEmail">
                  {{ $t("Bao.verify_email") }}
                </template>
                <template v-if="isShowVerifyPhone">
                  {{ $t("Bao.verify_phone") }}
                </template>
              </h4>
              <div class="reg-form-group">
                <div class="reg-form-area">
                  <div class="colu colu-auto">
                    <label class="colu-12 colu-form-label title-label let-lessen">
                      <template v-if="isShowVerifyEmail">
                        {{ $t("Bao.verify_email_code") }}
                      </template>
                      <template v-if="isShowVerifyPhone">
                        {{ $t("Bao.verify_phone_code") }}
                      </template>
                    </label>
                    <div class="colu-12">
                      <input
                        v-if="isShowVerifyEmail"
                        v-model="verifyEmailCode"
                        class="colu-12 for-input inpType"
                        :class="{ 'isInvalid': shouldShowEmailError}"
                        type="text"
                        name="emailValidateCode"
                        autocomplete="off"
                        @input="validateEmailCode"
                      >
                      <input
                        v-if="isShowVerifyPhone"
                        v-model="verifyPhoneCode"
                        class="colu-12 for-input inpType"
                        :class="{ 'isInvalid': shouldShowPhoneError}"
                        type="text"
                        name="phoneValidateCode"
                        autocomplete="off"
                        @input="validatePhoneCode"
                      >
                    </div>
                    <div v-if="shouldShowEmailError || shouldShowPhoneError" class="input-feedback text-align-R">
                      {{ $t("Bao.validate_code_error") }}
                    </div>
                  </div>
                  <div>
                    <div class="form-button form-ft">
                      <button
                        class="btn btn-tertiary"
                        :disabled="isShowVerifyEmail ? isMailButtonDisabled : isPhoneButtonDisabled"
                        @click.prevent="isShowVerifyEmail ? verifyMail() : verifyPhone()"
                      >
                        <span>{{ $t("Bao.verify_register") }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="colu-auto">
                    <i class="icon-alert">
                      <img :src="$getThemeImagePath('icon-detail.png')" alt="">
                    </i>
                    <b>{{ $t("Bao.email_notice_4") }}</b>
                    <span v-if="isShowVerifyEmail" class="let-lessen">{{ $t("Bao.email_notice_5") }}</span>
                    <span v-if="isShowVerifyPhone" class="let-lessen">{{ $t("Bao.phone_notice_5") }}</span>
                  </div>
                  <div class="colu-auto">
                    <b>{{ $t("Bao.email_notice_1") }}</b>
                  </div>
                  <div class="colu-auto">
                    <p v-if="isShowVerifyEmail">
                      {{ $t("Bao.email_notice_2") }} {{ $t("Bao.email_notice_3") }}
                    </p>
                    <p v-if="isShowVerifyPhone">
                      {{ $t("Bao.phone_notice_3") }}
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="authen-btn-wrap">
                  <button
                    class="btn-primary goTo-fun-sec-authen btn-mb-w-100 btn-resend"
                    :disabled="timerCount"
                    @click="getVerificationPop"
                  >
                    <i v-show="timerCount" class="fa fa-spinner fa-pulse fa-fw" />
                    <span>{{ timerCount ? '' + limitSecond + 's' : $t('Bao.get_verification_code') }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <iframe-verify v-if="verifyUrlFromStore" />
    </div>

    <!-- 密碼設定彈窗 -->
    <div v-if="showVerifyPassword" class="verify-code-wrap">
      <div class="popup-wrap verify-code-wrap" :class="{'active': showVerifyPassword}">
        <user-verify-code :type="passwordType" @close="showVerifyPassword = false" />
      </div>
    </div>
  </div>
</template>

<script>
import { update, getPhoneCode, verifyPhoneCode, getEmailCode, verifyEmailCode, phoneCheck, getThirdPartyKycUrl } from '@/api/user'
import { setErrorMessage, showNotice, showRestrictedAccountError } from '@/utils/tool'
import { getNationalityOptions, sanitizeNameField, getNameFieldLabels, getNameFieldPlaceholders } from '@/utils/nationality'
import iframeVerify from '@/components/modal/iframeGame'
import userVerifyCode from '@/components/modal/userVerifyCode'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'

export default {
  components: {
    iframeVerify,
    userVerifyCode
  },
  mixins: [themeMixin],
  data() {
    return {
      updateUser: {},
      romanizationOfLastName: '',
      romanizationOfFirstName: '',
      romanLastError: '',
      romanFirstError: '',
      lastName: '',
      firstName: '',
      maxDate: new Date().toISOString().split('T')[0],
      isShowVerifyPhone: false,
      phone: '',
      verifyPhoneCode: '',
      isShowVerifyEmail: false,
      email: '',
      verifyEmailCode: '',
      timerCount: true,
      limitSecond: 180,
      isPhoneValid: false,
      phoneError: '',
      emailCodeTouched: false,
      phoneCodeTouched: false,
      isActive: false,
      selectedCode: '',
      phoneWithoutCode: '',
      showVerifyPassword: false,
      passwordType: ''
    }
  },
  computed: {
    ...mapGetters(['brand', 'user', 'memberInfo', 'permissionInfo', 'socialType']),
    nationalityOptions() {
      return getNationalityOptions(this.brand.supportNationality)
    },
    nameLabels() {
      const override = getNameFieldLabels(this.updateUser.nationality)
      return {
        nameLast: override ? override.nameLast : this.$t('Bao.last_name'),
        nameFirst: override ? override.nameFirst : this.$t('Bao.first_name'),
        romLast: override ? override.romLast : this.$t('Bao.romanization_of_last_name'),
        romFirst: override ? override.romFirst : this.$t('Bao.romanization_of_first_name')
      }
    },
    namePlaceholders() {
      return getNameFieldPlaceholders(this.updateUser.nationality)
    },
    showKycTips() {
    // 如果有第三方 kyc 驗證
      if (this.kyc_brand) {
        return true
      }

      // 未經過驗證 或 已驗證的情況
      if (!this.kyc_brand &&
        (this.memberInfo.is_pass_KYC === 0 || this.memberInfo.is_pass_KYC === 1)) {
        return true
      }

      return false
    },
    kyc_brand() {
      return this.brand.info.kyc_brand !== 'self'
    },
    isSendButtonDisabled() {
      if (!this.isTheme('theme_purple')) {
        return this.memberInfo.email_validate === 0 || this.memberInfo.phone_validate === 0
      }
      return false
    },
    isMailButtonDisabled() {
      return this.verifyEmailCode === null || this.verifyEmailCode.trim() === ''
    },
    isPhoneButtonDisabled() {
      return this.verifyPhoneCode === null || this.verifyPhoneCode.trim() === ''
    },
    verifyUrlFromStore() {
      return this.$store.state.app.gameUrl
    },
    isSetData() {
      return this.memberInfo.name !== '' && this.memberInfo.romanization !== '' &&
             this.memberInfo.birthday !== '' && this.memberInfo.address !== '' &&
             this.memberInfo.email_validate === 1 &&
             this.memberInfo.phone_validate === 1 &&
             this.memberInfo.withdrawal_pass !== ''
    },
    emailCodeInvalid() {
      return this.verifyEmailCode.trim() === ''
    },
    phoneCodeInvalid() {
      return this.verifyPhoneCode.trim() === ''
    },
    shouldShowEmailError() {
      return this.emailCodeTouched && this.emailCodeInvalid
    },
    shouldShowPhoneError() {
      return this.phoneCodeTouched && this.phoneCodeInvalid
    },
    isShowKYC() {
      return this.permissionInfo.enable_kyc_certification !== 0
    },
    // 是否顯示個資欄位：已與 KYC 開關脫鉤，改吃獨立開關 register_need_member_info（後端預設 1）
    isShowMemberInfo() {
      return this.permissionInfo.register_need_member_info !== 0
    },
    email_need_verify() {
      return this.permissionInfo.email_need_verify
    },
    mode() {
      return this.email_need_verify ? 'email' : 'phone'
    }
  },
  watch: {
    romanizationOfLastName(newLastName) {
      this.updateUser.romanization = newLastName + ',' + this.romanizationOfFirstName
    },
    romanizationOfFirstName(newFirstName) {
      this.updateUser.romanization = this.romanizationOfLastName + ',' + newFirstName
    },
    lastName(newLastName) {
      this.updateUser.name = newLastName + ',' + this.firstName
    },
    firstName(newFirstName) {
      this.updateUser.name = this.lastName + ',' + newFirstName
    },
    'brand.supportPhoneCode': {
      handler(newVal) {
        if (newVal && newVal.length > 0 && !this.selectedCode) {
          if (this.memberInfo.phone_validate === 1) {
            const matchedCode = newVal.find(code => this.memberInfo.phone.startsWith(code))
            this.selectedCode = matchedCode || ''
          } else if (this.memberInfo.phone_validate === 0 && this.memberInfo.phone) {
            const matchedCode = newVal.find(code => this.memberInfo.phone.startsWith(code))
            this.selectedCode = matchedCode || newVal[0]
          } else {
            this.selectedCode = newVal[0]
          }
        }
      },
      immediate: true
    },
    selectedCode(newCode) {
      if (this.memberInfo.phone && newCode) {
        const oldCode = this.brand.supportPhoneCode.find(code =>
          this.memberInfo.phone.startsWith(code)
        )
        if (oldCode) {
          this.phoneWithoutCode = this.memberInfo.phone.substring(oldCode.length)
        }
      }
    },
    'updateUser.nationality'() {
      this.sanitizeAllNameFields()
    }
  },
  created() {
    this.initUpdateUser()
    this.debounceCheckPhone = this.debounce(this.phoneApiCall, 500)
  },
  methods: {
    openIframe() {
      const kyc_url = this.$store.state.user.kyc_url
      if (kyc_url) {
        this.$store.commit('SET_GAME_URL', kyc_url)
        this.$store.commit('SET_KYC_VERIFY', true)
      } else {
        getThirdPartyKycUrl().then(response => {
          if (response.data.data.code === 0) {
            this.$store.commit('SET_GAME_URL', response.data.data.url)
            this.$store.commit('SET_KYC_VERIFY', true)
          } else {
            showNotice(response.data.data.message)
          }
        }).catch((error) => {
          showNotice(error.response.data.msg)
        })
      }
    },
    debounce: function(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    initUpdateUser() {
      this.romanizationOfLastName = this.memberInfo.romanization ? this.memberInfo.romanization.split(',')[0] : ''
      this.romanizationOfFirstName = this.memberInfo.romanization ? this.memberInfo.romanization.split(',')[1] : ''
      this.lastName = this.memberInfo.name ? this.memberInfo.name.split(',')[0] : ''
      this.firstName = this.memberInfo.name ? this.memberInfo.name.split(',')[1] : ''

      if (this.memberInfo.phone && this.selectedCode) {
        this.phone = this.memberInfo.phone.startsWith(this.selectedCode)
          ? this.memberInfo.phone.substring(this.selectedCode.length)
          : this.memberInfo.phone
      } else {
        this.phone = this.memberInfo.phone
      }

      this.updateUser = {
        romanization: this.memberInfo.romanization,
        name: this.memberInfo.name,
        newPassword: '',
        confirmPassword: '',
        withdrawal_pass: '',
        address: this.memberInfo.address,
        birthday: this.memberInfo.birthday,
        phone: this.phone,
        email: this.memberInfo.email,
        nationality: this.memberInfo.nationality || ''
      }
    },
    // 手機驗證成功後，只重新同步手機欄位，保留使用者尚未儲存的其他個資
    syncPhoneAfterVerify() {
      if (this.memberInfo.phone && this.selectedCode) {
        this.phone = this.memberInfo.phone.startsWith(this.selectedCode)
          ? this.memberInfo.phone.substring(this.selectedCode.length)
          : this.memberInfo.phone
      } else {
        this.phone = this.memberInfo.phone
      }
      this.updateUser.phone = this.phone
    },
    // 信箱驗證成功後，只重新同步信箱欄位，保留使用者尚未儲存的其他個資
    syncEmailAfterVerify() {
      this.email = this.memberInfo.email
      this.updateUser.email = this.memberInfo.email
    },
    phoneApiCall() {
      if (this.phone && this.phone.trim() !== '') {
        phoneCheck({ phone: this.selectedCode + this.phone }).then(res => {
          this.phoneError = this.$t('Bao.phone_available')
          this.isPhoneValid = true
        }).catch(err => {
          console.log(err)
          this.phoneError = this.$t('Bao.phone_error')
          this.isPhoneValid = false
        })
      }
    },
    phonecheck() {
      if (!this.phone) {
        this.phoneError = this.$t('Bao.phone_error')
        this.isPhoneValid = false
      } else {
        this.debounceCheckPhone()
      }
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.limitSecond > 0) {
          this.limitSecond--
        } else {
          this.timerCount = false
          this.limitSecond = 180
          clearInterval(timer)
        }
      }, 1000)
    },
    getVerificationPop() {
      if (this.isShowVerifyEmail) {
        this.goVerifyEmail()
        return
      } else {
        this.goVerifyPhone()
      }
    },
    closeVerify() {
      this.isShowVerifyEmail = false
      this.isShowVerifyPhone = false
    },
    openVerifyPassword(type) {
      // 第三方登入的帳號不可變更登入密碼
      if (type === 'login' && this.socialType && this.socialType !== 'account') {
        showNotice(this.$t('Bao.password_cannot_change'))
        return
      }
      this.passwordType = type
      this.showVerifyPassword = true
    },
    goVerifyPhone() {
      // 第三方登入的帳號不可變更已驗證的手機（尚未綁定者可新增）
      if (this.socialType && this.socialType !== 'account' && this.memberInfo.phone_validate === 1) {
        showNotice(this.$t('Bao.phone_email_cannot_change'))
        return
      }
      getPhoneCode({ phone: this.selectedCode + this.phone }).then(response => {
        // 第三方帳號：後端可能以 200 回應 data.code=14
        if (showRestrictedAccountError(response)) {
          return
        }
        this.countDown()
        showNotice(response.data.msg)
        this.isShowVerifyPhone = true
      }).catch((error) => {
        if (!showRestrictedAccountError(error)) {
          showNotice(error.response.data.msg)
        }
      })
    },
    verifyPhone() {
      verifyPhoneCode(
        {
          phone: this.selectedCode + this.phone,
          validateCode: this.verifyPhoneCode
        }
      ).then(response => {
        if (showRestrictedAccountError(response)) {
          return
        }
        this.isShowVerifyPhone = false
        showNotice(this.$t('Bao.update_success'))
        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.syncPhoneAfterVerify()
      }).catch((error) => {
        if (!showRestrictedAccountError(error)) {
          showNotice(error.response.data.msg)
        }
      })
    },
    goVerifyEmail() {
      // 第三方登入的帳號不可變更已驗證的信箱（尚未綁定者可新增）
      if (this.socialType && this.socialType !== 'account' && this.memberInfo.email_validate === 1) {
        showNotice(this.$t('Bao.phone_email_cannot_change'))
        return
      }
      if (!this.updateUser.email && this.memberInfo.email) {
        this.updateUser.email = this.memberInfo.email
      }

      this.email = this.updateUser.email
      this.getMailCode(this.email)
    },
    getMailCode(mail) {
      getEmailCode({ email: mail }).then(response => {
        // 第三方帳號：後端可能以 200 回應 data.code=14
        if (showRestrictedAccountError(response)) {
          return
        }
        this.isShowVerifyEmail = true
        this.countDown()
        showNotice(response.data.msg)
      }).catch((error) => {
        if (!showRestrictedAccountError(error)) {
          showNotice(error.response.data.msg)
        }
        this.isShowVerifyEmail = false
      })
    },
    verifyMail() {
      verifyEmailCode({ email: this.email, validateCode: this.verifyEmailCode }).then(response => {
        if (showRestrictedAccountError(response)) {
          return
        }
        this.isShowVerifyEmail = false
        showNotice(this.$t('Bao.update_success'))
        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.syncEmailAfterVerify()
      }).catch((error) => {
        if (!showRestrictedAccountError(error)) {
          showNotice(error.response.data.msg)
        }
      })
    },
    save() {
      // lite player 只需輸入提款密碼即可保存
      if (this.memberInfo.member_type === 3) {
        this.updateUser.email = this.email
        const selectedCode = this.isTheme('theme_purple') ? '' : this.selectedCode
        this.updateUser.phone = selectedCode + this.phone
        update(this.updateUser).then(response => {
          if (showRestrictedAccountError(response)) {
            return
          }
          showNotice(this.$t('Bao.update_success'))
          this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
          this.initUpdateUser()
        }).catch((error) => {
          if (!showRestrictedAccountError(error)) {
            setErrorMessage(error.response, this.errors)
          }
        })
      } else {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.updateUser.email = this.email
            const selectedCode = this.isTheme('theme_purple') ? '' : this.selectedCode
            this.updateUser.phone = selectedCode + this.phone

            update(this.updateUser).then(response => {
              if (showRestrictedAccountError(response)) {
                return
              }
              if (this.memberInfo.is_pass_KYC === 1) {
                showNotice(this.$t('Bao.update_success'))
              } else if (this.kyc_brand && this.memberInfo.is_pass_KYC !== 1) {
                this.openIframe()
              } else if (!this.kyc_brand) {
                this.$router.push('/user/KYC')
              }

              this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
              this.initUpdateUser()
            }).catch((error) => {
              if (!showRestrictedAccountError(error)) {
                setErrorMessage(error.response, this.errors)
              }
            })
          }
        })
      }
    },
    pleaseEnterTip(filed) {
      return this.$t('Bao.' + filed) + this.$t('Bao.please_input')
    },
    validateRomLastName(e) {
      if (e && e.isComposing) return
      this.romanizationOfLastName = sanitizeNameField(this.romanizationOfLastName, this.updateUser.nationality, 'romanization')
    },
    validateRomFirstName(e) {
      if (e && e.isComposing) return
      this.romanizationOfFirstName = sanitizeNameField(this.romanizationOfFirstName, this.updateUser.nationality, 'romanization')
    },
    validateNameLast(e) {
      if (e && e.isComposing) return
      this.lastName = sanitizeNameField(this.lastName, this.updateUser.nationality, 'name')
    },
    validateNameFirst(e) {
      if (e && e.isComposing) return
      this.firstName = sanitizeNameField(this.firstName, this.updateUser.nationality, 'name')
    },
    sanitizeAllNameFields() {
      this.validateRomLastName()
      this.validateRomFirstName()
      this.validateNameLast()
      this.validateNameFirst()
    },
    validateEmailCode() {
      this.emailCodeTouched = true
    },
    validatePhoneCode() {
      this.phoneCodeTouched = true
    },
    toggleActive() {
      if (this.memberInfo.phone_validate === 1) {
        return
      }

      this.isActive = !this.isActive
    },
    selectCode(code) {
      if (this.memberInfo.phone_validate === 1) {
        return
      }

      this.isActive = false
      this.selectedCode = code

      if (this.phone && this.phone.trim() !== '') {
        this.debounceCheckPhone()
      }
    }
  }
}
</script>
